import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {EmiUtil} from '../../utils/emi.util';
import {CommonModule} from '@angular/common';
import {MatSortModule} from '@angular/material/sort';
import {MatInputModule} from '@angular/material/input';
import {MatTableModule} from '@angular/material/table';
import {MatSelectModule} from '@angular/material/select';
import {StorageService} from '../../service/storage.service';
import {XirrCalculator} from '../../service/xirr-calculator';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {DoughnutModule} from '../../doughnut/doughnut.module';
import {MatPaginatorModule} from '@angular/material/paginator';
import {ManualInvestComponent} from './manual-invest.component';
import {PortfolioService} from '../../service/portfolio.service';
import {CashFlowGenerator} from '../../utils/cash-flow-generator';
import {InvestmentNavigator} from '../../utils/investment-navigator';
import {InvestmentTitleComponent} from './investment-title.component';
import {ManualInvestRoutingModule} from './manual-invest-routing.module';
import {RatingSelectorModule} from '../rating-selector/rating-selector.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {ConfirmPopUpModule} from '../../comfirm-pop-up/confirm-pop-up.module';
import {CommonSectionsModule} from '../../views/common/common-sections.module';
import {SelectedManualInvestmentsGuard} from './selected-manual-investments.guard';
import {ConfirmPopUpComponent} from '../../comfirm-pop-up/confirm-pop-up.component';
import {ManualInvestListedLoansResolver} from './manual-invest-listed-loans.resolver';
import {PortfolioCreationDataResolver} from '../resolvers/portfolio-creation-data-resolver';
import {SelectedPreferencesModule} from '../selected-preferences/selected-preferences.module';
import {ManualinvestsummaryComponent} from '../manualinvestsummary/manualinvestsummary.component';
import {PortfolioPreferenceResolver} from '../portfolio-preference/portfolio-preference.resolver';
import {PortfolioPreferenceComponent} from '../portfolio-preference/portfolio-preference.component';
import {RateOfReturnTooltipModule} from '../../rate-of-return-tooltip/rate-of-return-tooltip.module';
import {FilledPercentageFilterPipe, LocationFilterPipe, RatingFilterPipe, SingleRatingFilterPipe} from './manual-invest.pipe';
import {MatButtonModule} from '@angular/material';

@NgModule({
    providers: [ManualInvestListedLoansResolver, PortfolioService, StorageService, InvestmentNavigator, SelectedManualInvestmentsGuard,
        PortfolioPreferenceResolver, PortfolioCreationDataResolver, XirrCalculator, EmiUtil, CashFlowGenerator],
    declarations: [ManualInvestComponent, InvestmentTitleComponent, PortfolioPreferenceComponent, ManualinvestsummaryComponent,
        FilledPercentageFilterPipe, LocationFilterPipe, SingleRatingFilterPipe, RatingFilterPipe],
    imports: [ManualInvestRoutingModule, CommonSectionsModule, MatSelectModule, CommonModule, FormsModule, ConfirmPopUpModule,
        MatTableModule, MatPaginatorModule, MatCheckboxModule, MatInputModule, MatSortModule, MatProgressSpinnerModule, MatButtonModule,
        RateOfReturnTooltipModule, DoughnutModule, SelectedPreferencesModule, RatingSelectorModule],
    entryComponents: [ConfirmPopUpComponent]
})
export class ManualInvestModule {
}